import type { ChartAdditionalParams } from 'shared/domain/analytics/chartModel';
import { keepIssuesOfVisibleProcesses } from '../model';
import {
  ChartValuesAndLabels,
  FilterValues,
  IssueChart,
} from 'shared/types/analytics';
import { get as getHazardCategories } from 'serviceWorker/db/fieldValues/hazardCategories/hazardCategories';
import { IssueEntity } from 'serviceWorker/repository/issue/entity';
import { HashMap, LabelledEntity } from 'shared/types/commonView';
import {
  increaseEntitySeries,
  increaseNoneSeries,
  toSortedValuesAndLabels,
} from '../seriesCreation';
import { filterIssuesByChartFilters } from '../issueChartFilters';

export async function createSeriesAndLabelsFromIssuesWithFilters(
  issues: IssueEntity[],
  filters: FilterValues,
  timezone: string,
  additionalParams: ChartAdditionalParams | undefined
): Promise<ChartValuesAndLabels> {
  const hazardTypesLabels = {};
  const hazardCategoriesMap = (await getHazardCategories()).reduce(
    (map, hazardCategory) => {
      map.set(hazardCategory._id, {
        _id: hazardCategory._id,
        label: hazardCategory.label,
      });
      return map;
    },
    new Map<string, LabelledEntity>()
  );

  const filteredIssues = keepIssuesOfVisibleProcesses(
    filterIssuesByChartFilters(
      issues,
      IssueChart.hsHazardType,
      filters,
      timezone
    ),
    additionalParams
  );

  const reducedToHazardTypeSummary = filteredIssues.reduce<
    HashMap<number>
  >((result, issue) => {
    const { hazardCategory } = issue.extendedData;
    if (hazardCategory && hazardCategory.length > 0) {
      hazardCategory.forEach((category) => {
        increaseEntitySeries(
          result,
          hazardTypesLabels,
          hazardCategoriesMap.get(category)!
        );
      });
    } else {
      increaseNoneSeries(result, hazardTypesLabels);
    }

    return result;
  }, {});

  return Promise.resolve(
    toSortedValuesAndLabels(reducedToHazardTypeSummary, hazardTypesLabels)
  );
}
